import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { SqliteWrapperService } from '../sqlite-wrapper/sqlite-wrapper.service';
import { SqliteObjectWrapper } from '../sqlite-wrapper/sqlite-object-wrapper';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { BehaviorSubject, from, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, concatMap, filter, map, switchMap, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
import { ConexionServiceProvider } from '../index.providers';
import { ConnectionStatus } from '../conexion-service/conexion-service';
import { VideoUploadService } from '../capture-video/video-upload.service';
import { ChecklistOfflineService } from '../checklist-offline/checklist-offline.service';
import { ToastService } from '../toast-service/toast.service';
import { LanguageService } from '../language-service/language.service';
export interface ChecklistSyncProgress {
  syncInProgress: boolean;
  checklistId: number;
  entityId: number;
  progressPercentage: number;
  status: 'pending' | 'syncing' | 'synced' | 'error';
  checklistIsFinished: boolean,
}
// export interface ChecklistSyncProgress {
//   checklistId: number;
//   entityId: number;
//   totalActivities: number;
//   syncedActivities: number;
//   progressPercentage: number;
//   status: 'pending' | 'syncing_activities' | 'syncing_checklist' | 'synced' | 'error';
//   errorMessage?: string;
//   syncInProgress: boolean;
//   checklistIsFinished: boolean,
// }
@Injectable({
  providedIn: 'root'
})
export class SyncService {
  private database: SqliteObjectWrapper;
  private isConnected = false;
  private isSyncing = false;
  // public syncStatusSubject = new Subject<any>();
  private networkObservable: Subscription;
  language:string = "es";
  translations;

 private syncProgressSubject = new BehaviorSubject<ChecklistSyncProgress | null>(null);
 public syncProgressSubject$ = this.syncProgressSubject.asObservable();

  constructor(
    private sqlite: SqliteWrapperService,
    private file: File,
    // private network: Network,
    private apiService: ApiService,
    private networkService: ConexionServiceProvider,
    private videoUploadService: VideoUploadService,
    private checklistOfflineService: ChecklistOfflineService,
    private toastService: ToastService,
    private languageService: LanguageService,

  ) {
    // this.setupNetworkListener();
    this.subLanguageConfig();
  }

  async createSQLdb() {
    console.log("createSQLdb")
    try {
      const userData = JSON.parse(localStorage.getItem("user_data"));
      if (!userData?.dni) return;
      const db = await this.sqlite.create({
        name:`${userData.dni}.db`,
        location: "default"
      });
      console.log('** checklist Database opened: ', db);
      if(db) {this.database = db};
    } catch (error) {
      console.error('** checklist Error opening database', error);
      // throw error
    }
  }
  // Inicializar la base de datos
  private async initDatabase(): Promise<SqliteObjectWrapper> {
    if (!this.database) {
      await this.createSQLdb();
    }
    return this.database;
  }

  removeDatabaseRef() {
    this.database = null;
    // console.log("removeDatabaseRef",  this.database)
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
      this.languageService.getChecklistTranslateFile(this.language).subscribe(
        {
          next: (data) => {
          this.translations = data;
          // console.log("translations ch::", this.translations)
          },
          error: (e) => {
            console.log(e);
          }
        }
      );
    });
  }

    // checkNewtworkStatus() {
    //   this.networkObservable =  this.networkService.onNetworkChange().subscribe(async (status: ConnectionStatus) => {
    //     this.isConnected = status === ConnectionStatus.Online;
    //     console.log("setupNetworkListener1:", this.isConnected)
    //   });
    // }

  async checkAndSyncIfNeeded() {
    this.networkObservable =  this.networkService.onNetworkChange().subscribe(async (status: ConnectionStatus) => {
      this.isConnected = status === ConnectionStatus.Online;
      console.log("SyncService isConnected:", this.isConnected, "database::",this.database)
      if(this.isConnected) {
        this.validateSync();
      }
    });

  }

  validateSync() {
    this.resetChecklistSyncStatus();
    setTimeout(async () => {
      // Verificar si hay datos pendientes y sincronizar
        const hasPendingData = await this.hasPendingData();
        if (hasPendingData) {
          // await this.resetChecklistSyncStatus();
          // this.syncService.forceSyncIfOnline();
          this.startSync();
        }
    }, 5000);
  }

  async resetChecklistSyncStatus() {
    try {
      await this.initDatabase();
      const tableExists = await this.checkTableExists('offline_checklist_audits');
      if (!tableExists) return;
      const query = `UPDATE offline_checklist_audits SET sync_status = ? WHERE has_data_to_sync = 1 AND is_synced = 0`;
      await this.database.executeSql(query, ["pending"]);
      console.log("resetChecklistSyncStatus to pending!" );
    } catch (error) {
      console.log("error resetChecklistSyncStatus", error);
    };
  }


  // Iniciar el proceso de sincronización
  public async startSync(): Promise<void> {
    console.log("startSync!!!!!!!!!!!", this.isConnected)
    if (!this.isConnected || this.isSyncing) {
      console.log('No hay conexión o ya está sincronizando');
      return;
    }

    try {
      this.isSyncing = true;

      await this.initDatabase();
      // Primero, sincronizar actividades con sus respectivos checklist
      await this.syncActivities();

      // Luego , sincronizar checklists que no tengan actividades pero si data genral de checklist ejem:knockout
      await this.syncChecklists();

      this.isSyncing = false;
      // this.syncStatusSubject.next({
      //     syncInProgress: false,
      //     checklistId: null,
      //     checklistIsFinished: null,
      //     entityId: null,
      //     status: ''
      // });

      console.log('Sincronización completada con éxito');
    } catch (error) {
      console.error('Error en el proceso general de sincronización:', error);
      this.isSyncing = false;

      this.syncProgressSubject.next({
        syncInProgress: false,
        checklistId: null,
        entityId: null,
        progressPercentage: 0,
        status: 'error',
        checklistIsFinished: false,
      });

      await this.markChecklistAsErrorSynced();
    }
  }

  // Sincronizar checklists finalizados (de uno en uno)
  private async syncChecklists(): Promise<void> {
    console.log("SINCRONIZANDO CHECKLIST -DATA GENERAL::")
    try {
      // Obtener todos los checklists pendientes de sincronizar
      const pendingChecklists = await this.getPendingChecklists();

      if (pendingChecklists.length === 0) {
        console.log('No hay checklists pendientes para sincronizar');
        return;
      }

      console.log(`2.Se encontraron ${pendingChecklists.length} checklists para sincronizar`, pendingChecklists);

      // Procesar cada checklist de forma secuencial
      for (let i = 0; i < pendingChecklists.length; i++) {
        const checklist = pendingChecklists[i];
        // Actualizar estado a 'syncing'
        await this.checklistOfflineService.updateSyncStatus(checklist.checklistId, checklist.entityId, 'syncing');

        this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: checklist.checklistId,
          entityId: checklist.entityId,
          progressPercentage: 10,
          status: 'syncing',
          checklistIsFinished: false,
        });

        try {
          // Enviar el checklist al servidor
          await this.sendChecklistToServer(checklist);

          this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: checklist.checklistId,
          entityId: checklist.entityId,
          progressPercentage: 70,
          status: 'syncing',
          checklistIsFinished: false,
        });

          // Marcar como sincronizado en la base de datos local
          await this.markChecklistAsSynced(checklist,checklist.checklistId, checklist.entityId);

          // Actualizar estado a 'synced'
          await this.checklistOfflineService.updateSyncStatus(checklist.checklistId, checklist.entityId, 'synced');

          this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: checklist.checklistId,
          entityId: checklist.entityId,
          progressPercentage: 100,
          status: 'synced',
          checklistIsFinished:  checklist.finishes_at ? true : false,
          });

        } catch (error) {
          console.error(`Error sincronizando checklist: ${checklist.checklistId}-${checklist.entityId}::`, error);
          // Actualizar estado a 'error'
          await this.checklistOfflineService.updateSyncStatus(checklist.checklistId, checklist.entityId, 'error');

          this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: checklist.checklistId,
          entityId: checklist.entityId,
          progressPercentage: 0,
          status: 'error',
          checklistIsFinished: false,
          });

          // throw error;
        };
      };

      console.log('Sincronización de checklists completada');
    } catch (error) {
      console.error('Error al sincronizar checklists-obtener ch:', error);
      throw error;
    }
  }

  // Sincronizar actividades (en grupos de 20)
  private async syncActivities(): Promise<void> {
    try {
      // Obtener todas las actividades pendientes de sincronizar
      const pendingActivities = await this.getPendingActivities();

      if (pendingActivities.length === 0) {
        console.log('No hay actividades pendientes para sincronizar');
        return;
      };

      // Obtener todos los checklists pendientes de sincronizar
      const pendingChecklists = await this.getPendingChecklists();
      console.log(`1.Se encontraron ${pendingChecklists.length} checklists para sincronizar junto a sus act:`, pendingChecklists);
      console.log(`Se encontraron ${pendingActivities.length} actividades para sincronizar`, pendingActivities);

      // Inicializar el progreso para todos los checklists
      // await this.initializeProgress(pendingActivities, pendingChecklists);

      // Agrupar actividades por checklistId
      const activitiesByChecklist = {};
      for (const activity of pendingActivities) {
        const checklistKey = `${activity.checklistId}-${activity.entityId}`;
        if (!activitiesByChecklist[checklistKey]) {
          activitiesByChecklist[checklistKey] = [];
        }
        activitiesByChecklist[checklistKey].push(activity);
      }

      console.log(`Actividades agrupadas por ${Object.keys(activitiesByChecklist).length} checklists`);

      // Constantes para el tamaño de los batches y seguimiento
      const batchSize = 20;

      // Procesar cada grupo de checklist
      for (const checklistKey in activitiesByChecklist) {
        const checklistActivities = activitiesByChecklist[checklistKey];
        const totalActivitiesInChecklist = checklistActivities.length;
        const [checklistId, entityId] = checklistKey.split('-');
        console.log(`Procesando ${totalActivitiesInChecklist} actividades para checklist ${checklistKey}`);

        // this.updateChecklistProgress(checklistKey, { status: 'syncing_activities'});
        this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: Number(checklistId),
          entityId: Number(entityId),
          progressPercentage: 1,
          status: 'syncing',
          checklistIsFinished: false,
        });

        let syncedInCurrentChecklist = 0;
        let hasErrorInCurrentChecklistActivities = false;

        for (let i = 0; i < checklistActivities.length; i += batchSize) {
          const batch = checklistActivities.slice(i, i + batchSize);
           try {
              await this.sendActivitiesBatchToServer(batch);

              syncedInCurrentChecklist += batch.length;

              this.syncProgressSubject.next({
                syncInProgress: true,
                checklistId: Number(checklistId),
                entityId: Number(entityId),
                progressPercentage: Math.round((syncedInCurrentChecklist / totalActivitiesInChecklist) * 80), // hasta 80% para actividades
                status: 'syncing',
                checklistIsFinished: false,
              });

              for (const activity of batch) {
                await this.markActivityAsSynced(activity);
              };

              this.syncProgressSubject.next({
                syncInProgress: true,
                checklistId: Number(checklistId),
                entityId: Number(entityId),
                progressPercentage: Math.round((syncedInCurrentChecklist / totalActivitiesInChecklist) * 90), // hasta 90% para actividades
                status: 'syncing',
                checklistIsFinished: false,
              });
              // this.updateChecklistProgress(checklistKey, {
              //   syncedActivities: syncedInCurrentChecklist,
              //   progressPercentage: Math.round((syncedInCurrentChecklist / totalActivitiesInChecklist) * 90) // hasta 90% para actividades
              // });

              console.log(`Batch de ${batch.length} actividades sincronizado para checklist ${checklistKey}`);
              console.log(`Progreso del checklist ${checklistKey}: ${syncedInCurrentChecklist}/${totalActivitiesInChecklist}`);
           } catch (error) {
            console.error(`Error sincronizando batch para checklist ${checklistKey} Saltando batches restantes y continuando con el siguiente checklist:`, error);
            hasErrorInCurrentChecklistActivities = true;
            // this.updateChecklistProgress(checklistKey, {
            //   status: 'error',
            //   errorMessage: 'Error al sincronizar actividades'
            // });

            const [checklistId, entityId] = checklistKey.split('-');
            this.syncProgressSubject.next({
              syncInProgress: true,
              checklistId: Number(checklistId),
              entityId: Number(entityId),
              progressPercentage: 0,
              status: 'error',
              checklistIsFinished: false,
            });

            await this.markChecklistAsErrorSynced(checklistId, entityId);

            break;
           };
        };

        //* AQUÍ ES DONDE DETECTO QUE TODAS LAS ACTIVIDADES DE UN CHECKLIST FUERON ENVIADAS ENTONCES FINALIZO EL CHECKLIST
        if (!hasErrorInCurrentChecklistActivities){
          if (syncedInCurrentChecklist === totalActivitiesInChecklist) {
            console.log(`(actividades) del checklist ${checklistKey} completamente sincronizadas.`);
            // Extraer checklistId y entityId del key
            const [checklistId, entityId] = checklistKey.split('-');
            try {
              // Emitir estado de sincronizando checklist (90-100%)
              this.syncProgressSubject.next({
                syncInProgress: true,
                checklistId: Number(checklistId),
                entityId: Number(entityId),
                progressPercentage: 93,
                status: 'syncing',
                checklistIsFinished: false,
              });
              // this.updateChecklistProgress(checklistKey, {
              //   status: 'syncing_checklist',
              //   progressPercentage: 95
              // });
              const checklistToSync = pendingChecklists.find(checklist => checklist.checklistId == checklistId && checklist.entityId == entityId);
              //siempre habrá un checklistToSync correspondiente a las actividades, la validación solo es por si las dudas, pero es uncaos que no debería pasar
              if(checklistToSync) {
                await this.checklistOfflineService.updateSyncStatus(checklistToSync.checklistId, checklistToSync.entityId, 'syncing');

                // Emitir estado de sincronizando checklist (90-100%)
                this.syncProgressSubject.next({
                  syncInProgress: true,
                  checklistId: checklistToSync.checklistId,
                  entityId: checklistToSync.entityId,
                  progressPercentage: 96,
                  status: 'syncing',
                  checklistIsFinished: false,
                });

                await this.sendChecklistToServer(checklistToSync);
                // Emitir estado de sincronizando checklist (90-100%)
                this.syncProgressSubject.next({
                  syncInProgress: true,
                  checklistId: checklistToSync.checklistId,
                  entityId: checklistToSync.entityId,
                  progressPercentage: 98,
                  status: 'syncing',
                  checklistIsFinished: false,
                });
                await this.markChecklistAsSynced(checklistToSync,checklistToSync.checklistId, checklistToSync.entityId);
                // Actualizar estado a 'synced'
                await this.checklistOfflineService.updateSyncStatus(checklistToSync.checklistId, checklistToSync.entityId,'synced');

                // Emitir completado (100%)
                 // this.updateChecklistProgress(checklistKey, {
                //   status: 'synced',
                //   progressPercentage: 100
                // });
                this.syncProgressSubject.next({
                  syncInProgress: true,
                  checklistId: checklistToSync.checklistId,
                  entityId: checklistToSync.entityId,
                  progressPercentage: 100,
                  status: 'synced',
                  checklistIsFinished: checklistToSync.finishes_at ? true : false,
                });
              } else {
                this.syncProgressSubject.next({
                  syncInProgress: true,
                  checklistId:  Number(checklistId),
                  entityId: Number(entityId),
                  progressPercentage: 100,
                  status: 'synced',
                  checklistIsFinished: false
                });
              };

            } catch (error) {
              console.error(`Error al sincronizar data global de checklist ${checklistKey}:`, error);
              // this.updateChecklistProgress(checklistKey, {
              //   status: 'error',
              //   errorMessage: 'Error al finalizar checklist'
              // });
              // Emitir error
              this.syncProgressSubject.next({
                syncInProgress: true,
                checklistId: Number(checklistId),
                entityId: Number(entityId),
                progressPercentage: 0,
                status: 'error',
                checklistIsFinished: false,
              });
              await this.markChecklistAsErrorSynced(checklistId, entityId);
            };
          };
        };
      };

    } catch (error) {
      console.error('Error general al sincronizar actividades:', error);
      throw error;
    }
  }

  // 4. INICIALIZAR PROGRESO PARA TODOS LOS CHECKLISTS
  // private async initializeProgress(pendingActivities: any[], pendingChecklists: any[]): Promise<void> {
  //   const progressMap = new Map<string, ChecklistSyncProgress>();

  //   // Contar actividades por checklist
  //   const activitiesCount = {};
  //   for (const activity of pendingActivities) {
  //     const checklistKey = `${activity.checklistId}-${activity.entityId}`;
  //     activitiesCount[checklistKey] = (activitiesCount[checklistKey] || 0) + 1;
  //   }

  //   // Inicializar progreso para cada checklist
  //   for (const checklistKey in activitiesCount) {
  //     const [checklistId, entityId] = checklistKey.split('-');

  //     progressMap.set(checklistKey, {
  //       checklistId: Number(checklistId),
  //       entityId: Number(entityId),
  //       totalActivities: activitiesCount[checklistKey],
  //       syncedActivities: 0,
  //       progressPercentage: 0,
  //       status: 'pending'
  //     });
  //   }

  //   this.syncProgressSubject.next(progressMap);
  // }

  // 5. ACTUALIZAR PROGRESO DE UN CHECKLIST ESPECÍFICO
  // private updateChecklistProgress(checklistKey: string, updates: Partial<ChecklistSyncProgress>): void {
  //   const currentProgress = this.syncProgressSubject.value;
  //   const checklistProgress = currentProgress.get(checklistKey);

  //   if (checklistProgress) {
  //     const updatedProgress = { ...checklistProgress, ...updates };
  //     currentProgress.set(checklistKey, updatedProgress);
  //     this.syncProgressSubject.next(new Map(currentProgress));
  //   }
  // }

  // Obtener checklists pendientes de sincronización
  private async getPendingChecklists(): Promise<any[]> {
    try {
      const tableExists = await this.checkTableExists('offline_checklist_audits');
      if (!tableExists) return [];

      const result = await this.database.executeSql(
        `SELECT * FROM offline_checklist_audits WHERE has_data_to_sync = 1 AND is_synced = 0 AND sync_status NOT IN (?, ?)`,
        ['synced', 'error']
      );

      const checklists = [];
      if(result.rows.length) {
        for (let i = 0; i < result.rows.length; i++) {
          checklists.push(result.rows.item(i));
        }
      }

      console.log("Obtener checklists pendientes de sincronización", checklists)
      return checklists;
    } catch (error) {
      console.error('Error al obtener checklists pendientes:', error);
      return [];
    }
  }

  async checkTableExists(tableName: string): Promise<boolean> {
  try {
    const result = await this.database.executeSql(
      `SELECT name FROM sqlite_master WHERE type='table' AND name=?`,
      [tableName]
    );
    return result.rows.length > 0;
  } catch (error) {
    console.error('Error checking table existence:', error);
    return false;
  }
}

  // Obtener actividades pendientes de sincronización
  private async getPendingActivities(): Promise<any[]> {
    const activities = [];
    try {
      const tableExists = await this.checkTableExists('offline_audits');

      if (!tableExists) {
        console.log('La tabla offline_audits no existe');
      } else {
        const result = await this.database.executeSql(
          `SELECT * FROM offline_audits WHERE is_synced = 0`,
          []
        );

        for (let i = 0; i < result.rows.length; i++) {
          activities.push(result.rows.item(i));
        };
      };

      for (const audit of activities)   {
        audit.comments = audit.comments ? JSON.parse(audit.comments) : '';
        audit.photos = audit.photos ? JSON.parse(audit.photos) : [];
        audit.videos = audit.videos ? JSON.parse(audit.videos) : [];
        audit.qualification_id = audit.qualification_id ? JSON.parse(audit.qualification_id) : {};

         for (let videoData of audit.videos)  {
            try {
              if(videoData.action === "insert") {
                // Crear blob desde el path
                const blob = await this.videoUploadService.createBlobFromPath(videoData.url);
                videoData.file_video = blob;
              } else {
                videoData.file_video = ""
              }
            } catch (error) {
              console.error(`Error procesando video  a blob: ${videoData.url}:`, error);
              videoData.file_video = "";
            };
         };
      };

      console.log("@@@@@ Obtener actividades pendientes de sincronización ", activities)
      return activities;
    } catch (error) {
      console.error('Error al obtener actividades pendientes:', error);
      throw error;
    }
  }

  // Enviar un checklist al servidor
  private async sendChecklistToServer(checklist: any): Promise<void> {
    try {
      // Preparar los datos para el envío
      const checklistData = {
        checklist_id: checklist.checklistId,
        action_plan: checklist.action_plan,
        signature_supervisor: checklist.signature_supervisor,
        // signature_supervised: JSON.parse(checklist.signature_supervised || ""),
        entity_id: checklist.entityId,
        starts_at: checklist.starts_at,
        finishes_at: checklist.finishes_at
      };

      if (checklist.signature_supervised) {
        checklistData['signature_supervised'] = JSON.parse(checklist.signature_supervised);
      } else {
        checklistData['signature_supervised'] = ""
      };

      if (checklist.knockout) {
        checklistData['knockout'] = JSON.parse(checklist.knockout);
      } else {
        checklistData['knockout'] = ""
      };

      // Enviar al servidor
      await this.apiService.finishChecklistOffline(checklist.checklistId, checklistData).toPromise();
    } catch (error) {
      throw error;
    }
  }

  // Enviar un lote de actividades al servidor
  private async sendActivitiesBatchToServer(activities: any[]): Promise<void> {
    const checklistIdReference = activities[0]?.checklistId;
    const entityIdReference = activities[0]?.entityId;

    try {
      // Preparar los datos para el envío
      const activitiesData = activities.map(activity => ({
        checklist_id: activity.checklistId,
        entity_id: activity.entityId,
        activity_id: activity.activity_id,
        qualification_id: activity.qualification_response ? {} : activity.qualification_id,
        qualification_response: activity.qualification_response,
        date_audit: activity.date_audit,
        comment: activity.comments,
        photos: activity.photos,
        videos: activity.videos
      }));

      // Enviar al servidor
      const syncActivitiesRes =  await this.apiService.syncActivitiesBatch(activities[0].checklistId,activitiesData)
      console.log("syncActivitiesRes::",syncActivitiesRes)
      // await this.apiService.syncActivitiesBatch(activities[0].checklistId,activitiesData).toPromise();
      console.log(`Lote de ${activities.length} actividades del checklist ${checklistIdReference}-entidad:${entityIdReference} enviado a servidor correctamente`);
    } catch (error) {
      console.error(`Error al enviar a servidor lote de actividades: checklist ${checklistIdReference}-entidad:${entityIdReference} `, error);
      // this.syncStatusSubject.next({
      //   syncInProgress: true,
      //   checklistId: checklistIdReference,
      //   checklistIsFinished: false,
      //   entityId: entityIdReference,
      //   status: 'error'
      // });
      throw error;
    }
  }

  // Marcar un checklist como sincronizado
  private async markChecklistAsSynced(checklist, checklistId: string,entityID ): Promise<void> {
    console.log("markChecklistAsSynced:", checklist.finishes_at)
    try {
      if(checklist.finishes_at) {
        await this.database.executeSql(
          `UPDATE offline_checklist_audits SET is_synced = 1 WHERE id = ?`,
          [`${entityID}-${checklistId}`]
        );
        console.log(`Checklist ${entityID}-${checklistId} marcado como sincronizado`);
      } else {
        await this.database.executeSql(
          `UPDATE offline_checklist_audits SET sync_status = ? WHERE id = ?`,
          ['synced', `${entityID}-${checklistId}`]
        );
        console.log(`Checklist ${entityID}-${checklistId} enviado pero no marcado como sincronizado por aún estar en desarrollo`);
      };
    } catch (error) {
      console.error(`Error al marcar checklist ${entityID}-${checklistId} como sincronizado:`, error);
      throw error;
    }
  }
  // Marcar checklist con error de sincronización
  private async markChecklistAsErrorSynced(checklistId?, entityId?): Promise<void> {
    try {
      if(checklistId && entityId) {
        await this.database.executeSql(
          `UPDATE offline_checklist_audits SET sync_status = ? WHERE checklistId = ? AND entityId = ? AND is_synced = 0`,
          ["error",Number(checklistId), Number(entityId)]
        );
      } else {
        await this.database.executeSql(
          `UPDATE offline_checklist_audits SET sync_status = ? WHERE is_synced = 0`,
          ["error"]
        );
      }
      console.log(`Checklists marcados como error en sync_status`);
    } catch (error) {
      console.error(`Error al marcar checklist como error en sync_status:`, error);
      throw error;
    }
  }

  // Marcar una actividad como sincronizada
  private async markActivityAsSynced(activity): Promise<void> {
    console.log("markActivityAsSynced", activity)
    try {
      await this.database.executeSql(
        `UPDATE offline_audits SET is_synced = 1 WHERE activity_id = ?  AND entityId = ?  AND checklistId = ?`,
        [activity.activity_id, activity.entityId , activity.checklistId ]
      );
      if(activity.photos?.length) {
        activity.photos.forEach(async (photo) => {
          const markPhotosAsSynced = {
            ...photo,
            isSynced: 1
          };

          await this.checklistOfflineService.createInsertActivitiesPhotosTable( markPhotosAsSynced, activity.checklistId, activity.entityId, activity.activity_id);
        });
        //  const temporalPhotoId = `${checklist_id}-${this.id_entity_selected}-${data.activity_id}-${newPhoto.datetime}`;
      };

      if(activity.videos && activity.videos.length) {
        activity.videos.forEach(async (video) => {
          const markVideosAsSynced = {
            ...video,
            isSynced: 1
          };
          await this.checklistOfflineService.createInsertActivitiesVideosTable( markVideosAsSynced, activity.checklistId, activity.entityId, activity.activity_id);

        });
      }
      console.log(`Actividad ${activity.activity_id} ${activity.checklistId} ${activity.entityId} marcada como sincronizada`);
    } catch (error) {
      console.error(`Error al marcar actividad ${activity.activity_id} ${activity.entityId} ${activity.checklistId} como sincronizada:`, error);
      throw error;
    }
  }

  // Nuevo método para reintentar sincronización
  public async retrySync(checklistId: number, entityId: number = null) {
    try {
      this.isConnected = this.networkService.getCurrentNetworkStatus() === ConnectionStatus.Online;
      // Actualizar estado a 'pending'
      if(entityId) {
        await this.checklistOfflineService.updateSyncStatus( checklistId, entityId, 'pending' );
      } else {
        await this.checklistOfflineService.updateSyncStatusByUniqueEntityInChecklist( checklistId, 'pending' );
      }
      // this.syncStatusSubject.next({
      //     syncInProgress: true,
      //     checklistId: checklistId,
      //     entityId: entityId,
      //     checklistIsFinished: false,
      //     status: 'syncing'
      // });

      // Forzar sincronización
      // this.forceSyncIfOnline();
      if (this.isConnected && !this.isSyncing) {
        this.syncProgressSubject.next({
          syncInProgress: true,
          checklistId: checklistId,
          entityId: entityId,
          progressPercentage: 0,
          status: 'syncing',
          checklistIsFinished: false,
        });

        this.startSync();
      } else if (!this.isConnected) {
        this.toastService.presentToast("warning", this.translations?.ACTIVITY.SIN_INTERNET , 4000, "top");
        // this.syncStatusSubject.next({
        //   syncInProgress: false,
        //   checklistId: checklistId,
        //   checklistIsFinished: false,
        //   entityId: entityId,
        //   status: 'error'
        // });
        this.syncProgressSubject.next({
          syncInProgress: false,
          checklistId: null,
          entityId: null,
          progressPercentage: 0,
          status: 'error',
          checklistIsFinished: false,
        });
      } else {
        console.log('Ya hay una sincronización en progreso');
        this.toastService.presentToast("warning", this.translations?.ACTIVITY.SINCRONIZACION_EN_PROGRESO , 4000, "top");
      }
    } catch (error) {
      console.error('Error al reintentar sincronización:', error);
    }
  }

  // Método para verificar si hay datos pendientes de sincronizar
  public async hasPendingData(): Promise<boolean> {
    await this.initDatabase();

    let checklistsCount = 0;
    let activitiesCount = 0;

    // Verificar checklists pendientes
    try {
      const checklistTableExists = await this.checkTableExists('offline_checklist_audits');
      if (checklistTableExists) {
        const checklistsResult = await this.database.executeSql(
          `SELECT COUNT(*) as count FROM offline_checklist_audits WHERE has_data_to_sync = 1 AND is_synced = 0`,
          []
        );
        checklistsCount = checklistsResult.rows.item(0).count;
      }
    } catch (error) {
      checklistsCount = 0;
      console.log(error)
    };

    // Verificar actividades pendientes
    try {
      const auditsTableExists = await this.checkTableExists('offline_audits');
      if (auditsTableExists) {
        const activitiesResult = await this.database.executeSql(
          `SELECT COUNT(*) as count FROM offline_audits WHERE is_synced = 0`,
          []
        );
        activitiesCount = activitiesResult.rows.item(0).count;
      }
    } catch (error) {
      activitiesCount = 0;
      console.log(error)
    };

    console.log("hay checklist o actividades por sincronizar (revisar log Data de act. por sincronizar)::  ","checklistsCount:",checklistsCount ,"activitiesCount::",activitiesCount)
    return checklistsCount > 0 || activitiesCount > 0;
  }

  // Método para limpiar datos ya sincronizados
  public async cleanSyncedData(): Promise<void> {
    await this.initDatabase();

    try {
      if (await this.checkTableExists('offline_checklist_audits')) {
        await this.database.executeSql(`DELETE FROM offline_checklist_audits WHERE is_synced = 1`, []);
      }
      if (await this.checkTableExists('offline_audits')) {
        await this.database.executeSql(`DELETE FROM offline_audits WHERE is_synced = 1`, []);
      }
      console.log('Datos sincronizados eliminados correctamente');
    } catch (error) {
      console.error('Error al limpiar datos sincronizados:', error);
      throw error;
    }
  }
}
